var _style, _rect, _g, _g2, _g3, _path, _path2, _g4, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayEnUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "135px",
    height: "40px",
    viewBox: "0 0 135 40",
    style: {
      enableBackground: "new 0 0 135 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;fill-opacity:0;}\n\t.st1{fill:#A6A6A6;}\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.2;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_1_);}\n\t.st5{fill:url(#SVGID_00000034806373519808934820000011849314936814250660_);}\n\t.st6{fill:url(#SVGID_00000030458004059591318180000018016516847754282422_);}\n\t.st7{fill:url(#SVGID_00000068649423434819293530000001080620883223204522_);}\n\t.st8{opacity:0.2;enable-background:new    ;}\n\t.st9{opacity:0.12;enable-background:new    ;}\n\t.st10{opacity:0.25;fill:#FFFFFF;enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -10,
    className: "st0",
    width: 155,
    height: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130,40H5c-2.75,0-5-2.25-5-5V5c0-2.75,2.25-5,5-5h125c2.75,0,5,2.25,5,5v30C135,37.75,132.75,40,130,40z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130,0.8c2.32,0,4.2,1.88,4.2,4.2v30c0,2.32-1.88,4.2-4.2,4.2H5c-2.32,0-4.2-1.88-4.2-4.2V5 c0-2.32,1.88-4.2,4.2-4.2H130 M130,0H5C2.25,0,0,2.25,0,5v30c0,2.75,2.25,5,5,5h125c2.75,0,5-2.25,5-5V5C135,2.25,132.75,0,130,0 L130,0z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.42,10.24c0,0.84-0.25,1.51-0.75,2c-0.56,0.59-1.3,0.89-2.2,0.89c-0.87,0-1.6-0.3-2.21-0.9 c-0.61-0.6-0.91-1.35-0.91-2.23c0-0.89,0.3-1.63,0.91-2.23c0.61-0.6,1.34-0.9,2.21-0.9c0.43,0,0.84,0.08,1.23,0.25 c0.39,0.17,0.7,0.39,0.94,0.67l-0.53,0.53c-0.4-0.47-0.94-0.71-1.64-0.71c-0.63,0-1.18,0.22-1.64,0.67 c-0.46,0.44-0.69,1.02-0.69,1.73s0.23,1.29,0.69,1.73c0.46,0.44,1.01,0.67,1.64,0.67c0.67,0,1.23-0.22,1.68-0.67 c0.29-0.29,0.46-0.7,0.5-1.22h-2.18V9.79h2.91C47.4,9.95,47.42,10.1,47.42,10.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.03,7.74H49.3v1.9h2.46v0.72H49.3v1.9h2.73V13h-3.5V7h3.5V7.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.28,13h-0.77V7.74h-1.68V7h4.12v0.74h-1.68V13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.94,13V7h0.77v6H59.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.13,13h-0.77V7.74h-1.68V7h4.12v0.74h-1.68V13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.61,12.22c-0.59,0.61-1.32,0.91-2.2,0.91c-0.88,0-1.61-0.3-2.2-0.91c-0.59-0.61-0.88-1.35-0.88-2.22 s0.29-1.62,0.88-2.22c0.59-0.61,1.32-0.91,2.2-0.91c0.87,0,1.6,0.3,2.2,0.91c0.59,0.61,0.89,1.35,0.89,2.22 C74.49,10.88,74.2,11.62,73.61,12.22z M69.78,11.72c0.44,0.45,0.99,0.67,1.63,0.67c0.64,0,1.19-0.22,1.63-0.67 c0.44-0.45,0.67-1.02,0.67-1.72s-0.22-1.27-0.67-1.72C72.6,7.83,72.05,7.6,71.41,7.6c-0.64,0-1.19,0.22-1.63,0.67 C69.34,8.73,69.11,9.3,69.11,10S69.34,11.27,69.78,11.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.58,13V7h0.94l2.92,4.67h0.03l-0.03-1.16V7h0.77v6h-0.8l-3.05-4.89h-0.03l0.03,1.16V13H75.58z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.14,21.75c-2.35,0-4.27,1.79-4.27,4.25c0,2.45,1.92,4.25,4.27,4.25c2.35,0,4.27-1.8,4.27-4.25 C72.41,23.54,70.49,21.75,68.14,21.75z M68.14,28.58c-1.29,0-2.4-1.06-2.4-2.58c0-1.53,1.11-2.58,2.4-2.58 c1.29,0,2.4,1.05,2.4,2.58C70.54,27.52,69.42,28.58,68.14,28.58z M58.82,21.75c-2.35,0-4.27,1.79-4.27,4.25 c0,2.45,1.92,4.25,4.27,4.25c2.35,0,4.27-1.8,4.27-4.25C63.09,23.54,61.17,21.75,58.82,21.75z M58.82,28.58 c-1.29,0-2.4-1.06-2.4-2.58c0-1.53,1.11-2.58,2.4-2.58c1.29,0,2.4,1.05,2.4,2.58C61.22,27.52,60.11,28.58,58.82,28.58z  M47.74,23.06v1.8h4.32c-0.13,1.01-0.47,1.76-0.98,2.27c-0.63,0.63-1.61,1.32-3.33,1.32c-2.66,0-4.74-2.14-4.74-4.8 s2.08-4.8,4.74-4.8c1.43,0,2.48,0.56,3.25,1.29l1.27-1.27c-1.08-1.03-2.51-1.82-4.53-1.82c-3.64,0-6.7,2.96-6.7,6.61 c0,3.64,3.06,6.61,6.7,6.61c1.97,0,3.45-0.64,4.61-1.85c1.19-1.19,1.56-2.87,1.56-4.22c0-0.42-0.03-0.81-0.1-1.13H47.74z  M93.05,24.46c-0.35-0.95-1.43-2.71-3.64-2.71c-2.19,0-4.01,1.72-4.01,4.25c0,2.38,1.8,4.25,4.22,4.25c1.95,0,3.08-1.19,3.54-1.88 l-1.45-0.97c-0.48,0.71-1.14,1.18-2.09,1.18c-0.95,0-1.63-0.44-2.06-1.29l5.69-2.35L93.05,24.46z M87.25,25.88 c-0.05-1.64,1.27-2.48,2.22-2.48c0.74,0,1.37,0.37,1.58,0.9L87.25,25.88z M82.63,30h1.87V17.5h-1.87V30z M79.57,22.7H79.5 c-0.42-0.5-1.22-0.95-2.24-0.95c-2.13,0-4.08,1.87-4.08,4.27c0,2.38,1.95,4.24,4.08,4.24c1.01,0,1.82-0.45,2.24-0.97h0.06v0.61 c0,1.63-0.87,2.5-2.27,2.5c-1.14,0-1.85-0.82-2.14-1.51l-1.63,0.68c0.47,1.13,1.71,2.51,3.77,2.51c2.19,0,4.04-1.29,4.04-4.43 v-7.64h-1.77V22.7z M77.42,28.58c-1.29,0-2.37-1.08-2.37-2.56c0-1.5,1.08-2.59,2.37-2.59c1.27,0,2.27,1.1,2.27,2.59 C79.7,27.5,78.7,28.58,77.42,28.58z M101.81,17.5h-4.47V30h1.87v-4.74h2.61c2.07,0,4.1-1.5,4.1-3.88S103.87,17.5,101.81,17.5z  M101.85,23.52H99.2v-4.29h2.65c1.4,0,2.19,1.16,2.19,2.14C104.04,22.35,103.25,23.52,101.85,23.52z M113.39,21.73 c-1.35,0-2.75,0.6-3.33,1.91l1.66,0.69c0.35-0.69,1.01-0.92,1.7-0.92c0.97,0,1.95,0.58,1.96,1.61v0.13 c-0.34-0.19-1.06-0.48-1.95-0.48c-1.79,0-3.6,0.98-3.6,2.81c0,1.67,1.46,2.75,3.1,2.75c1.25,0,1.95-0.56,2.38-1.22h0.06v0.97h1.8 v-4.79C117.18,22.97,115.52,21.73,113.39,21.73z M113.16,28.58c-0.61,0-1.46-0.31-1.46-1.06c0-0.96,1.06-1.33,1.98-1.33 c0.82,0,1.21,0.18,1.7,0.42C115.24,27.76,114.24,28.58,113.16,28.58z M123.74,22l-2.14,5.42h-0.06L119.32,22h-2.01l3.33,7.58 l-1.9,4.21h1.95L125.82,22H123.74z M106.94,30h1.87V17.5h-1.87V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.7996,
    y1: 173.2904,
    x2: 5.0172,
    y2: 156.508,
    gradientTransform: "matrix(1 0 0 -1 0 182.0002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.44,7.54c-0.29,0.31-0.46,0.79-0.46,1.4v22.12c0,0.62,0.17,1.1,0.46,1.4l0.07,0.07L22.9,20.15V20v-0.15 L10.51,7.47L10.44,7.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028286491308162340180000009536801691889349556_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.8343,
    y1: 161.9987,
    x2: 9.6374,
    y2: 161.9987,
    gradientTransform: "matrix(1 0 0 -1 0 182.0002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028286491308162340180000009536801691889349556_)"
    },
    d: "M27.03,24.28l-4.13-4.13V20v-0.15 l4.13-4.13l0.09,0.05l4.89,2.78c1.4,0.79,1.4,2.09,0,2.89l-4.89,2.78L27.03,24.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160896131811041558610000004756489987003473559_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.8269,
    y1: 159.704,
    x2: 2.0686,
    y2: 136.9457,
    gradientTransform: "matrix(1 0 0 -1 0 182.0002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160896131811041558610000004756489987003473559_)"
    },
    d: "M27.12,24.23L22.9,20L10.44,32.46 c0.46,0.49,1.22,0.55,2.08,0.06L27.12,24.23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011031216815783993890000018001834860718201494_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.2972,
    y1: 181.8239,
    x2: 17.4598,
    y2: 171.6614,
    gradientTransform: "matrix(1 0 0 -1 0 182.0002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011031216815783993890000018001834860718201494_)"
    },
    d: "M27.12,15.78l-14.61-8.3 c-0.86-0.49-1.62-0.43-2.08,0.06L22.9,20L27.12,15.78z"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M27.03,24.13l-14.52,8.25c-0.81,0.46-1.54,0.43-2,0.01l0,0l-0.07,0.07l0,0l0.07,0.07l0,0 c0.47,0.42,1.19,0.45,2-0.01l14.61-8.3L27.03,24.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M10.44,32.32c-0.29-0.31-0.46-0.79-0.46-1.4v0.15c0,0.62,0.17,1.1,0.46,1.4l0.07-0.07L10.44,32.32z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M32.01,21.3l-4.99,2.83l0.09,0.09l4.89-2.78c0.7-0.4,1.05-0.92,1.05-1.44l0,0 C33,20.47,32.65,20.94,32.01,21.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M12.51,7.62l19.5,11.08c0.63,0.36,0.99,0.82,1.05,1.3l0,0c0-0.52-0.35-1.05-1.05-1.44L12.51,7.48 c-1.4-0.79-2.54-0.13-2.54,1.47v0.15C9.97,7.49,11.12,6.83,12.51,7.62z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayEnUs);
export default __webpack_public_path__ + "static/media/google_play-en-us.75e3295ee16aa86acf7df43a476015f2.svg";
export { ForwardRef as ReactComponent };